import { defineComponent as _defineComponent } from 'vue'
import OptimizerIconV2 from '@sh/components/Utils/OptimizerIconV2.ts.vue';
import { computed, getCurrentInstance } from 'vue';
import { NavItem } from '../navItems';

interface Props {
  item: NavItem;
  collapsed: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarItem.ts',
  props: {
    item: null,
    collapsed: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  item: NavItem;
  collapsed: boolean;
};



const isActive = computed(() => {
  const instance = getCurrentInstance();
  const route = instance?.proxy.$route;
  return route?.path.includes(props.item.url);
});

return { __sfc: true,props, isActive, OptimizerIconV2 }
}

})